/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwa_Install_Ios_Step2Inputs */

const cs_pwa_install_ios_step2 = /** @type {(inputs: Pwa_Install_Ios_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zvolte „Přidat na plochu“ a potvrďte Přidat.`)
};

const en_pwa_install_ios_step2 = /** @type {(inputs: Pwa_Install_Ios_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose “Add to Home Screen”, then Add.`)
};

/**
* | output |
* | --- |
* | "Choose “Add to Home Screen”, then Add." |
*
* @param {Pwa_Install_Ios_Step2Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pwa_install_ios_step2 = /** @type {((inputs?: Pwa_Install_Ios_Step2Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwa_Install_Ios_Step2Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pwa_install_ios_step2(inputs)
	return cs_pwa_install_ios_step2(inputs)
});